import styled from "styled-components";

export const CartContainer = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;

export const ItemCountContainer = styled.span`
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  bottom: 12px;
`;
